/**
 * @fileover Helper functions for YearGrid.js, Change or update tooltip hovers here!
 * This file contains mappings for title to background color, text color, and tooltip text

 */

export const getBackgroundColor = (title) => {
  switch (title) {
    case "Vehicles":
      return "#eff0ef";
    case "Charging Infrastructure":
      return "#eff0ef";
    case "Totals":
      return "#eff0ef";
    case "Loan Information":
      return "#eff0ef";
    default:
      return "";
  }
};

export const getTextColor = (title, value) => {
  let textColor = "black";
  if (value === "-") {
    return "black";
  }
  if (
    title === "Total Annual O&M Savings" ||
    title === "Total Annual Costs" ||
    title === "Annual Marginal Cash Flow" ||
    title === "Cumulative Marginal Cash Flow" ||
    title === "Charger Incentives" ||
    title === "Charge Management Savings" ||
    title === "Total Vehicle Incentives" ||
    title === "Total Charging Infrastructure Savings"
  ) {
    if (value && (value[0] === "-" || value < 0)) {
      textColor = "black";
    } else {
      textColor = "green";
    }
  }
  return textColor;
};

export const tooltipMap = {
  "Total Electric Vehicles in Fleet":
    "Total number of electric vehicles in the fleet",
  "Total Charging Infrastructure Savings":
    "Savings from charging management and charger incentives, rebates, or credits",
  "Cost of Electric Vehicles": "Estimated MSRP ($) not including incentives.",
  "Estimated EV Maintenance Costs":
    "Lifetime operations and maintenance costs for all electrified vehicles up to this year.",
  "Total Annual ZEV Costs":
    "Total annual costs of ownership for zero-emission vehicles, including purchasing, operations, and maintenance.",
  "Total Vehicle Incentives":
    "Total savings from state, local, and federal incentives",
  "Electric Vehicle Charging Costs":
    "Costs of charging per kWh for all electrified vehicles up to this year.",
  "Default Vehicle Replacement Fund Allocation":
    "Estimated MSRP of the existing fleet vehicle",
  "Existing Vehicle Maintenance Costs":
    "Lifetime operations and maintenance costs for all non-electrified vehicles up to this year.",
  "Total Annual Costs":
    "Combines vehicle and charger annual costs of ownership.",
  "Cumulative Marginal Cash Flow":
    "Cumulative marginal costs or savings from electrification, accounting for all factors. Accounts for contingency.",
  "Annual Marginal Cash Flow":
    "Total annual marginal costs or savings from electrification, accounting for all factors. Accounts for contingency.",
  "Default Replacement Costs":
    "Total annual costs of ownership for fleet vehicles, if replaced with default options.",
  "Total Vehicle Savings": "Annual fueling and O&M savings",
  "Total Charging Infrastructure Costs":
    "Costs of purchasing, installing, and other support for charging infrastructure. Accounts for contingency.",
  "Total Annual O&M Savings":
    "Combines default replacement costs and infrastructure savings",
};
